import * as React from 'react';

import styled from 'styled-components';
import { ImageRetry } from '@webapp/components/basics/image-retry';
import LoadingCtrl from '@webapp/controllers/loading';

interface MerchImgProps {
  className?: string;
  product: string;
}

export const MerchImg: React.FC<MerchImgProps> = ({
  className,
  product,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const handleLoad = () => {
    setIsLoading(false);
  };

  return (
    <MerchImgWrapper>
      {isLoading ? <LoadingIndicator loading={isLoading} size="128px" /> : null}
      <MerchImgContainer
        className={className}
        src={product}
        setLoading={setIsLoading}
        handleLoad={handleLoad}
      />
    </MerchImgWrapper>
  );
};
export default MerchImg;

const MerchImgWrapper = styled.div`
  position: relative;
`;

const MerchImgContainer = styled(ImageRetry)`
  display: block;
  width: 100%;
  max-width: 340px;
  max-height: 340px;
  border-radius: 2px;
`;

const LoadingIndicator = styled(LoadingCtrl)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
